
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const features = [
    {
      icon: 'ri-user-heart-line',
      title: 'Experienced Dentists',
      description: 'Our team of dentists has years of experience and is passionate about providing exceptional dental care.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Technology',
      description: 'State-of-the-art equipment and modern techniques for precise, comfortable treatments.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Personalized Care',
      description: 'We tailor our treatment plans to meet your individual needs and preferences.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Affordable Pricing',
      description: 'Quality dental care at competitive prices with flexible payment options.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="mb-6 sm:mb-8">
              <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">About Us</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2 mb-4 sm:mb-6">
                The Tooth Doctor – Advanced Dental Care Centre
              </h2>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6">
                Welcome to The Tooth Doctor Dental Clinic in Thiruverkadu, Chennai. We're dedicated to providing 
                comprehensive dental care tailored to your unique needs. From routine check-ups to advanced treatments, 
                our experienced team is committed to ensuring your dental health and well-being.
              </p>
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8">
                At The Tooth Doctor, we believe in a personalized approach to dental care. We take the time to 
                understand your concerns, answer your questions, and develop a treatment plan that's right for you. 
                Our state-of-the-art facility combines modern technology with compassionate care.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-blue-600 text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{feature.title}</h4>
                    <p className="text-xs sm:text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link to="/about" className="w-full sm:w-auto">
                <Button variant="primary" size="lg" className="w-full sm:w-auto">
                  Learn More About Us
                </Button>
              </Link>
              <Button 
                variant="outline" 
                size="lg"
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="w-full sm:w-auto"
              >
                Schedule Consultation
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="relative order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/2cab7184c01580bfe565c7696c97e7d7.png" 
                alt="The Tooth Doctor Clinic"
                className="w-full h-[300px] sm:h-[400px] lg:h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
            </div>
            
            {/* Floating stats */}
            <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white rounded-xl shadow-lg p-4 sm:p-6 max-w-[140px] sm:max-w-xs">
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-500 rounded-full flex items-center justify-center">
                  <i className="ri-user-smile-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xl sm:text-2xl font-bold text-gray-900">1000+</p>
                  <p className="text-xs sm:text-sm text-gray-600">Happy Patients</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 sm:-top-6 sm:-right-6 bg-white rounded-xl shadow-lg p-4 sm:p-6 max-w-[140px] sm:max-w-xs">
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xl sm:text-2xl font-bold text-gray-900">15+</p>
                  <p className="text-xs sm:text-sm text-gray-600">Years Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
